import { createSlice } from "@reduxjs/toolkit";
import { coreApi } from "api/core";
import { setShowMessage } from "redux/slices/uiSlice";

const initialState = {
  importing: false,
  error: null,
  success: false,
  importedCount: 0,
  importErrors: [],
  message: "",
};

export const importOrdersFile = (file, date, departure, t) => async (dispatch) => {
  dispatch(importStart());

  try {
    const formData = new FormData();
    formData.append("file", file);
    if (date) {
      formData.append("date", date);
    }
    if (departure) {
      formData.append("departure", departure);
    }

    const response = await coreApi.post("/import/orders", formData, {

      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.success) {
      dispatch(
        setShowMessage({
  description: t("Imported successfully"),
          type: "success",
        })
      );
    }

    dispatch(importSuccess(response));
    return response;
  } catch (err) {
    const errorData = err.response?.data || {
      success: false,
      imported: 0,
      errors: [],
      message: "Error importing orders",
    };

    dispatch(importSuccess(errorData));
    return errorData;
  }
};

// Rest of the slice definition remains the same
const ordersImportSlice = createSlice({
  name: "ordersImport",
  initialState,
  reducers: {
    importStart: (state) => {
      state.importing = true;
      state.error = null;
      state.success = false;
      state.importedCount = 0;
      state.importErrors = [];
      state.message = "";
    },
    importSuccess: (state, action) => {
      state.importing = false;
      state.success = action.payload.success || false;
      state.error = null;
      state.importedCount = action.payload.imported || 0;
      const errs = action.payload.errors;
      state.importErrors = Array.isArray(errs) ? errs : [];
      state.message = action.payload.message || "";
    },
    importFailed: (state, action) => {
      state.importing = false;
      state.error = action.payload;
      state.success = false;
    },
    resetImportState: (state) => {
      state.importing = false;
      state.error = null;
      state.success = false;
      state.importedCount = 0;
      state.importErrors = [];
      state.message = "";
    },
  },
});

export const { importStart, importSuccess, importFailed, resetImportState } = ordersImportSlice.actions;
export default ordersImportSlice.reducer;
